import { motion } from 'framer-motion';

const ScanningAnimation = () => (
	<motion.div
		className="absolute inset-x-0 z-10 bg-accent blur-lg"
		animate={{
			top: ['10%', '100%'],
			height: ['4rem', '1rem'],
			opacity: [0, 1, 1, 1, 0],
			rotate: [-2, 2, -2, 2, -2],
			transition: {
				repeat: Infinity,
				repeatType: 'reverse',
				duration: 3,
			},
		}}
	/>
);

export default ScanningAnimation;
